import i18n from 'i18next';
import Routes from '../../constants/routes';
import SchoolAccount from '../../utils/school-account';

export const AUTHOR_TAB_ROUTE = '/de/autor/:id/:slug/:tab';
export const TAB_CHANGE_TRIGGER_EVENT = 'author-tab-change';

export enum PROFILE_TAB_URLS {
    MAIN = 'main',
    MATERIALS = 'materials',
    BLOG = 'blog',
    ACTIVITY = 'activity',
    FOLLOWING = 'following'
}

const href = (a: Author) => (a.isSeller ? Routes.AUTHOR_MAIN.fullpathTab : Routes.USER_PROFILE.fullpath);

export const AUTHOR_PAGE_LINKS = [
    {
        canShow: (a: Author) => a.isSeller,
        href,
        tab: PROFILE_TAB_URLS.MATERIALS,
        title: () => `${i18n.t('authorPage.info.materials')}`
    },
    {
        canShow: () => true,
        href,
        tab: PROFILE_TAB_URLS.BLOG,
        title: () => i18n.t('authorPage.info.blog')
    },
    {
        canShow: (a: Author, u: User) => !SchoolAccount.isAdmin(u),
        href,
        tab: PROFILE_TAB_URLS.ACTIVITY,
        title: () => i18n.t('authorPage.info.activity')
    },
    {
        canShow: () => true,
        href,
        tab: PROFILE_TAB_URLS.FOLLOWING,
        title: () => i18n.t('authorPage.info.following')
    }
];
